import React from 'react';
import { useKQSH } from '../../../features/kqsh';
import { useAuth } from '../../../features/auth/hooks/useAuth';
import KQSHCardList from '../../../features/kqsh/components/KQSHCardList';
import KQSHImportPanel from './KQSHImportPanel';
import './KQSHPage.scss';

const KQSHPage: React.FC = () => {
  const { data, loading, error } = useKQSH();
  const { role } = useAuth();
  const canImport = role === 'Admin';

  return (
    <div className="kq__page">
      <div className="kq__page-header">
        <h2 className="kq__title">Kết quả sát hạch</h2>
        {data?.hoTen && <p className="kq__hoten">Họ tên: <strong>{data.hoTen}</strong></p>}
      </div>

      {canImport && (
        <div className="kq__import-wrap">
          <KQSHImportPanel />
        </div>
      )}

      <KQSHCardList
        records={data?.records ?? []}
        loading={loading}
        error={error}
        emptyMessage="Chưa có kết quả. Dữ liệu được đồng bộ từ hệ thống sát hạch. Vui lòng liên hệ trung tâm nếu bạn đã thi nhưng chưa thấy kết quả."
      />
    </div>
  );
};

export default KQSHPage;
